import React from 'react';
import { FormattedMessage } from 'react-intl';
import SmartLink from '../../common/smart-link';

interface IFeaturedElementProps {
    isNew: boolean;
    title: string;
    imageUrl: string;
    imageAltText: string;
    callToActionLabel: string;
    callToActionUrl: string;
    target?: string;
}

const FeaturedItemElement = ({
    isNew,
    title,
    imageUrl,
    imageAltText,
    callToActionLabel,
    callToActionUrl,
    target,
}: IFeaturedElementProps) => {
    return (
        <div className="featured-item">
            <SmartLink
                className="text-left"
                to={callToActionUrl ? callToActionUrl : ''}
                title={imageAltText}
                style={{
                    background: `url(${imageUrl})`,
                    backgroundSize: 'Cover',
                    width: 'auto',
                }}
                target={target}
            >
                <div className="overlay">
                    <div className="row">
                        <div className="col-md-12">
                            {isNew && (
                                <span className="badge badge-secondary">
                                    <FormattedMessage
                                        id="New"
                                        defaultMessage="New"
                                    />
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div
                            className="col-md-12"
                            dangerouslySetInnerHTML={{ __html: title }}
                        ></div>
                    </div>
                    <br></br>
                </div>
            </SmartLink>
        </div>
    );
};

export default FeaturedItemElement;
